const monthYearFormatter = new Intl.DateTimeFormat("da-DK", {
  month: "long",
  year: "numeric",
});

const fullDateFormatter = new Intl.DateTimeFormat("da-DK", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

/** Stable "YYYY-MM" key used to group and to key accordion sections. */
export const monthYearKey = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

/** e.g. "september 2026" (callers capitalise via CSS). */
export const formatMonthYear = (date: Date): string =>
  monthYearFormatter.format(date);

/** e.g. "10. september 2026". */
export const formatReleaseDate = (date: Date): string =>
  fullDateFormatter.format(date);
